import { render, staticRenderFns } from "./InstallmentProductConfigList.vue?vue&type=template&id=cc04c430&scoped=true"
import script from "./InstallmentProductConfigList.vue?vue&type=script&lang=js"
export * from "./InstallmentProductConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc04c430",
  null
  
)

export default component.exports